import React, { useState, useRef } from "react";
import TimeInput from "./TimeInput";
import TemperatureInput from "./TemperatureInput";
import Timeline from "./Timeline";
import StepDurationEditor from "./StepDurationEditor";
import ShareTimeline from "./ShareTimeline";
import AdSense from "./AdSense";

const TimelineCalculator = ({
  temperature,
  onTemperatureChange,
  onTimeSubmit,
  timeline,
}) => {
  const [customDurations, setCustomDurations] = useState({});
  const timelineRef = useRef(null);

  const handleTimeSubmit = (timeInput) => {
    onTimeSubmit(timeInput, customDurations);
  };

  const handleDurationChange = (stepName, duration) => {
    setCustomDurations((prev) => ({
      ...prev,
      [stepName]: duration,
    }));
  };

  return (
    <div>
      <h1 className="mb-4">Timeline Calculator</h1>
      <TimeInput onTimeSubmit={handleTimeSubmit} />
      <TemperatureInput
        temperature={temperature}
        onTemperatureChange={onTemperatureChange}
      />
      <StepDurationEditor
        customDurations={customDurations}
        onDurationChange={handleDurationChange}
      />

      {/* AdSense Display Ad */}
      <div className="my-4">
        <AdSense adSlot="timeline-calculator-ad" />
      </div>

      {timeline && (
        <>
          <div ref={timelineRef}>
            <Timeline steps={timeline} />
          </div>
          <ShareTimeline
            timelineRef={timelineRef}
            timeline={timeline}
            temperature={temperature}
            customDurations={customDurations}
          />
        </>
      )}
    </div>
  );
};

export default TimelineCalculator;
